import {useCallback, useMemo, useState} from "react";
import {theme} from "Theme";

function useTable(rows, columns, rowActions, showTotals) {
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const headCells = rowActions
        ? [
              ...columns,
              {
                  id: "actions",
                  width: 7,
              },
          ]
        : columns;

    const emptyRows = useMemo(
        () => Math.max(0, (1 + page) * rowsPerPage - rows?.length),
        [page, rowsPerPage, rows]
    );

    const totalsColumns = useMemo(() => {
        if (!showTotals || columns?.length === 0) return;
        return columns.map(column => {
            if (column.calculateTotal) {
                return rows?.reduce((sum, row) => sum + (row[column.id] || 0), 0);
            } else {
                return null;
            }
        });
    }, [columns, rows, showTotals]);

    const getValue = (obj, path) => {
        for (var i = 0, path = path.split("."), len = path.length; i < len; i++) {
            if (!obj[path[i]]) {
                return null;
            }
            obj = obj[path[i]];
        }
        return obj;
    };

    const getCellStyle = useCallback(
        (column, element, small) => {
            const cellValue = column.formatFunction
                ? column.formatFunction(element)
                : getValue(element, column.id);

            const shouldHighlight =
                column.highlight ||
                (column.shouldHighlight && column.shouldHighlight(element, cellValue));

            const baseStyle = {
                fontSize: small ? "0.85rem" : "0.95rem",
                textAlign: column.align || "left",
            };

            if (!shouldHighlight) return baseStyle;

            const highlightStyle = {
                fontWeight: "bold",
                color: theme.palette.text.primary,
                ...(column.highlightStyle || {}),
            };

            return {
                ...baseStyle,
                ...highlightStyle,
            };
        },
        [theme]
    );

    return {
        page,
        handleChangePage,
        rowsPerPage,
        setRowsPerPage,
        emptyRows,
        getValue,
        getCellStyle,
        headCells,
        totalsColumns,
    };
}

export {useTable};
